
import React from 'react';

//MUI components
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';

// Redux tools and selectors
import { useSelector, useDispatch } from "react-redux";
import { periodHeuresSlice } from "../../../../../../store/periodSlice.js";
import { getRidingPeriod, getContrat } from "../../../../../../store/selectors.js";
import dayjs from 'dayjs';


//this component manage 1 select at a time
// props : horaire is 1 object with am and pm hours, closed or not
// props : index set which select (depart or return time)
function ListHoraires({ horaires, index }) { // destructuration à la déclaration : cover image, title of the house, id of house in database

  const dispatch = useDispatch();
  function handleChangeHeure(event) { // when time is changed
    let h = event.target.value; //value is the time as integer (ex : 17h00 -> 17)
    dispatch(periodHeuresSlice.actions.setHeure({ heure: +h, index: index })); //apply new value (time) to global state 
    dispatch(periodHeuresSlice.actions.setHeure({ heure: regulHeure(h, deltaHeures), index: 2 })); //apply new value (time) to global state 
  };

  function regulHeure(h1, delta) { // adapter l'heure de retour à la modif de l'heure de depart sans que ça modifie la durée de loc (jours, demi journéees)
    if (delta >= 0) { //h1 < H2

      if (h1 <= pauseDebut) {
        if (h1 + delta >= pauseDebut && pauseDebut !== pauseFin) {
          return pauseFin
        }
        else {
          return h1 + delta;
        }
      }
      else {
        if (h1 + delta >= fermeture) {
          return fermeture
        }
        else {
          return h1 + delta;
        }

      }

    }
    else { //h2 < h1

      if (h1 <= pauseDebut) {
        if (h1 + delta <= ouverture) {
          return ouverture
        }
        else {
          return h1 + delta;
        }
      }
      else {
        if (h1 + delta <= pauseFin && pauseDebut !== pauseFin) {
          return pauseDebut
        }
        else {
          return h1 + delta;
        }

      }

    }
  }


  let ridingPeriod = useSelector(getRidingPeriod); //array of 2 arrays (2 dates,2 times)
  let currentContrat = useSelector(getContrat); //
  let deltaHeures = currentContrat.h2 - currentContrat.h1;

  let heure = ridingPeriod[1][index - 1]; // get the correct time (based on index prop)


  //convert datas from object 'horaires' (prop)
  const ouverture = horaires.am_start;
  const pauseDebut = horaires.am_end;
  const pauseFin = horaires.pm_start;
  const fermeture = horaires.pm_end;
  const delta = pauseFin - pauseDebut;
  const ferme = (horaires.ferme === true); //is it closed today?

  let liste = []; // we prepare the list of select item
  if (ferme) {
    liste.push({ value: 0, text: " --- " })
  }
  else {
    if (pauseDebut !== pauseFin) { // if shop close for lunch

      if (delta > 1) {
        for (let h = ouverture; h <= pauseDebut; h++) {
          liste.push({ value: h, text: h + ":00" });
        }

        for (let h = pauseFin; h <= fermeture; h++) {
          liste.push({ value: h, text: h + ":00" });
        }
      }
    } else { //journée continue
      for (let h = ouverture; h <= fermeture; h++) {
        liste.push({ value: h, text: h + ":00" });
      }
    }

  }

  const checkValidHour = (heureLigne) => { //function to disable hours in select when date1 == date2, and we dont want start hour bigger than return hour
    //verify date1 == date2
    if (dayjs(ridingPeriod[0][0]).isSame(dayjs(ridingPeriod[0][1]))) { //same day
      if (index === 1) { //list hours of start
        return (heureLigne >= ridingPeriod[1][1]) // return TRUE (disable) when the hour of the line is bigger or equal than return hour (stored in Global state (ridingPeriod))
      }
      else {
        return (heureLigne <= ridingPeriod[1][0]) // return TRUE (disable) when the hour of the line is less or equal than start hour (stored in Global state (ridingPeriod))

      }

    }
    else { //different days
      return false;
    }
  }

  return (

    <FormControl>
      <InputLabel id="demo-simple-select-label">Heure</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select1"
        value={heure}
        label="Heure"
        disabled={true/* index === 2 */}
        onChange={handleChangeHeure}
        className='time-selecter'
      >
        { // add every object of the time list, to the select component
          liste.map((ligne) => <MenuItem key={ligne.value} value={ligne.value} disabled={checkValidHour(ligne.value)}>{ligne.text}</MenuItem>)
        }
      </Select>
    </FormControl>




  )
}



export default ListHoraires
